type ImageObject = {
  uid: string;
  url?: string;
  name?: string;
  thumbnail?: string;
  alt?: string | null;
};

// Fields that should be flattened to a single string UID if they contain images
const SINGULAR_IMAGE_FIELDS = [
  "banner_image",
  "cover_image",
  "mobile_banner",
  "feature_image",
];

export const transformImageFieldsToUIDs = <T extends Record<string, any>>(
  payload: T,
  flatten: boolean = false,
): T => {
  const isImageObjectArray = (arr: any[]): arr is ImageObject[] =>
    arr.length > 0 &&
    arr.every(
      (item) =>
        typeof item === "object" &&
        item !== null &&
        typeof item.uid === "string",
    );

  const isStringArray = (arr: any[]): arr is string[] =>
    arr.length > 0 && arr.every((item) => typeof item === "string");

  const result: Record<string, any> = {};

  for (const [key, value] of Object.entries(payload)) {
    const shouldFlatten = flatten || SINGULAR_IMAGE_FIELDS.includes(key);

    if (Array.isArray(value)) {
      if (value.length === 0) {
        result[key] = null;
      } else if (isImageObjectArray(value)) {
        const uids = value.map((img) => img.uid);
        if (shouldFlatten) {
          result[key] = uids.length === 1 ? uids[0] : uids.join(",");
        } else {
          result[key] = uids;
        }
      } else if (isStringArray(value) && shouldFlatten) {
        result[key] = value.length === 1 ? value[0] : value.join(",");
      } else {
        result[key] = value.map((item) =>
          typeof item === "object" && item !== null
            ? transformImageFieldsToUIDs(item, flatten)
            : item,
        );
      }
    } else if (typeof value === "object" && value !== null) {
      result[key] = transformImageFieldsToUIDs(value, flatten);
    } else {
      result[key] = value;
    }
  }

  return result as T;
};
